<template>
  <!--订单列表页面-->
  <tk-container
    disable-scroll
  >
    <!--头部-->
    <my-header :icon="'return'" slot="header">客户订单</my-header>
    <!--tab切换-->
    <tkui-tab around ref="goTabItem" @change="changeTab($event)" style="height: 100%;">
      <tkui-tab-item label="全部">
        <order-container :order-type="'all'" ref="clientAll" :order-middle="orderMiddleValue" :order-edit="editObj"></order-container>
      </tkui-tab-item>
      <tkui-tab-item label="待发货">
        <order-container :order-type="'toBeShipped'" ref="clientShipped" :order-middle="orderMiddleValue" :order-edit="editObj"></order-container>
      </tkui-tab-item>
      <tkui-tab-item label="已发货">
        <order-container :order-type="'pendingReceipt'" ref="clientPending" :order-middle="orderMiddleValue" :order-edit="editObj"></order-container>
      </tkui-tab-item>
      <tkui-tab-item label="已评价">
        <order-container :order-type="'completed'" ref="clientCompleted" :order-middle="orderMiddleValue" :order-edit="editObj"></order-container>
      </tkui-tab-item>
      <tkui-tab-item label="退换货">
        <order-container :order-type="'returnExchange'" ref="clientReturn" :order-middle="orderMiddleValue" :order-edit="editObj"></order-container>
      </tkui-tab-item>
    </tkui-tab>
  </tk-container>
</template>

<script>
import orderContainer from '@/components/orderContainer'
export default {
  components: {
    orderContainer
  },
  data () {
    return {
      status: 'loading', // 页面状态
      editObj: null,
      tabNum: 0
    }
  },
  computed: {
    orderMiddleValue () {
      return this.$store.state.orderMiddleValue
    }
  },
  mounted () {
    this.setStatusBar('dark')
    this.$refs.goTabItem.go(this.$route.query.tabIndex) // 切换到指定选项
  },
  beforeRouteLeave (to, from, next) {
    if (from.path === '/order/myOrderList') {
      this.$store.commit('setOrderMiddleValue', null)
    }
    next(true)
  },
  methods: {
    /**
     * 调用子组件方法
     * @date: 2020/6/8
     */
    changeTab (num) {
      if (Number(num) === this.tabNum) { return }
      this.tabNum = Number(num)
      if (this.tabNum === 0) { this.$refs.clientAll.refreshInitA() }
      if (this.tabNum === 1) { this.$refs.clientShipped.refreshInitA() }
      if (this.tabNum === 2) { this.$refs.clientPending.refreshInitA() }
      if (this.tabNum === 3) { this.$refs.clientCompleted.refreshInitA() }
      if (this.tabNum === 4) { this.$refs.clientReturn.refreshInitA() }
    }
  },
  hasFlash () {
    this.editObj = this.$getFlash('orderEdit')
  }
}
</script>

<style lang="scss" scoped>
  /*tab样式*/
  ::v-deep .tkui-tab .tabs-wrap {
    background-color: #fff;
    height: 45px !important;
    border-bottom: 1px solid #f5f5f5;
  }
  ::v-deep .tkui-tab .tabs-wrap .tab-item {
    font-size: 16px !important;
  }
  ::v-deep .tkui-tab .tabs-wrap .tab-item.active {
    color: rgba(207, 22, 19, 1) !important;
    font-weight: bold !important;
    font-size: 16px !important;
  }
  ::v-deep .tkui-tab .tabs-wrap .tab-item.active:before {
    background: rgba(207, 22, 19, 1);
    width: 40% !important;
    height: 2px !important;
    left: 30% !important;
  }
</style>
